import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { cardNum } from '@/services/http';
import { readCookie, writeCookie } from '@/tools/tools';
/**
 * getters
 */
// export const getters: GetterTree<CardState, RootState> = {
//   addresslist: (state: CardState) => state.cardnumber,
// };
/**
 * mutations
 */
export var mutations = {
  // 购物车变化
  CARDNUMBER: function CARDNUMBER(state, payload) {
    state.cardnumber = payload;
    writeCookie('cardNum', state.cardnumber);
  },
  // 修改购物车
  UPDATECARD: function UPDATECARD(state, payload) {
    state.cardnumber = payload;
  },
  SETCARDLIST: function SETCARDLIST(state, payload) {
    state.cardList = payload;
    writeCookie('cardlist', state.cardList);
  }
};
/**
 * actions
 */
export var actions = {
  setCardNum: function setCardNum(_ref) {
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var commit, res;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            commit = _ref.commit;
            _context.next = 3;
            return cardNum({
              companyId: 1
            });
          case 3:
            res = _context.sent;
            commit('CARDNUMBER', res.data.data);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
};
/**
 * state
 */
export var state = {
  cardnumber: readCookie('cardNum') ? readCookie('cardNum') : 0,
  cardList: readCookie('cardlist') ? readCookie('cardlist') : []
};
var namespaced = true;
export var card = {
  namespaced: namespaced,
  state: state,
  // getters,
  mutations: mutations,
  actions: actions
};